var _a, _b, _c;
import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { DEFAULT_FONT_FAMILY } from "../../foundations/typography.es.js";
import { palette, Common, Primary } from "../../foundations/palette.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
const textFieldStyleOverrides = {
  root: {
    fontFamily: DEFAULT_FONT_FAMILY,
    color: (_a = palette.text) == null ? void 0 : _a.secondary,
    "& .MuiOutlinedInput-root": {
      borderRadius: Spacing["500"],
      backgroundColor: Common.white.main,
      "&:has([readonly])": {
        backgroundColor: (_b = palette.action) == null ? void 0 : _b.selected,
        cursor: CursorStyle.notAllowed
      },
      "&.blocked": {
        backgroundColor: Primary.light,
        color: Primary.main,
        "& fieldset": {
          borderColor: Primary.main
        }
      },
      "&:has(.adornment-start)": {
        paddingLeft: 0
      },
      "&:has(.adornment-end)": {
        paddingRight: 0
      },
      "&.MuiInputBase-multiline": {
        backgroundColor: Common.white.main
      }
    },
    [`& .${MuiClassCollection.disabled}, & .${MuiClassCollection.readOnly}`]: {
      cursor: CursorStyle.notAllowed
    },
    "&.MuiTextField-sizeMedium": {
      "& .MuiInputBase-input": {
        padding: `${Spacing["1000"]} ${Spacing["750"]}`
      }
    },
    "&.MuiTextField-sizeSmall": {
      "& .MuiInputBase-input": {
        padding: `${Spacing["500"]} ${Spacing["750"]}`
      }
    },
    "& .adornment": {
      backgroundColor: (_c = palette.background) == null ? void 0 : _c.default,
      "&.MuiInputAdornment-positionEnd": {
        borderTopRightRadius: Spacing["500"],
        borderBottomRightRadius: Spacing["500"]
      },
      "&.MuiInputAdornment-positionStart": {
        borderTopLeftRadius: Spacing["500"],
        borderBottomLeftRadius: Spacing["500"]
      },
      "&.small": {
        paddingBottom: Spacing["1250"],
        paddingTop: Spacing["1250"],
        paddingRight: Spacing["750"],
        paddingLeft: Spacing["750"]
      },
      "&.medium": {
        paddingBottom: Spacing["1750"],
        paddingTop: Spacing["1750"],
        paddingRight: Spacing["1000"],
        paddingLeft: Spacing["1000"]
      }
    }
  }
};
export {
  textFieldStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
